import React, { Component } from "react";
import { SliderElement } from "../elements/input/slider-input.element";
import { Separator } from "../elements/separator.element";

function MxCostCalculatorQuestion({ children, minHeight = 105 }) {
  return (
    <p
      className="text-lg text-gray-800 pb-12 pt-12 md:pt-0"
      style={{ minHeight }}
    >
      {children}
    </p>
  );
}

export class MxCostCalculator extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      meetingScore: 50,
      employeesCount: 250,
      internalHourRate: 120,
      monthlyMeetingHours: 30,
      showDamage: false,
    };

    this.updateValue = this.updateValue.bind(this);
    this.updateValueSlider = this.updateValueSlider.bind(this);

    this.currencyFormatter = new Intl.NumberFormat("de-CH", {
      style: "currency",
      currency: "CHF",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  updateValue(evt) {
    const {
      target: { name, value, type },
    } = evt;

    this.setState({ [name]: type === "number" ? +value : value });
  }

  getMeetingDamagePerMonth(meetingScoreOverride = null) {
    const {
      meetingScore,
      employeesCount,
      internalHourRate,
      monthlyMeetingHours,
    } = this.state;

    if (
      ![
        meetingScore,
        employeesCount,
        internalHourRate,
        monthlyMeetingHours,
      ].every(val => typeof val === "number" && !isNaN(val))
    ) {
      return null;
    }

    if (meetingScore > 100) {
      return 0;
    }

    const meetingScoreCoeff = (100 - meetingScore) / 100;

    return Math.round(
      employeesCount *
        internalHourRate *
        monthlyMeetingHours *
        meetingScoreCoeff
    );
  }

  updateValueSlider(key, value) {
    this.setState({
      [key]: value,
    });
  }

  revealDamage() {
    this.setState({ showDamage: true });
  }

  render() {
    const damage = this.getMeetingDamagePerMonth();
    return (
      <div className="mb-24">
        <Separator text="Der Meeting Schadensrechner" isCenter={true} />

        <div className="flex flex-wrap">
          <div className="w-full md:w-1/2 px-6">
            <MxCostCalculatorQuestion>
              Wie viele <strong>Mitarbeitende</strong> sind in Ihrem Unternehmen
              angestellt? Geben Sie die Anzahl an.
            </MxCostCalculatorQuestion>

            <SliderElement
              start={this.state.employeesCount}
              onUpdate={value =>
                this.updateValueSlider("employeesCount", value)
              }
              min={0}
              max={10000}
              scaleCourve={{ min: 0, "50%": 100, "75%": 1000, max: 10000 }}
            />
          </div>
          <div className="w-full md:w-1/2 px-6">
            <MxCostCalculatorQuestion>
              Wie viele <strong>Stunden</strong> verbringt{" "}
              <strong>ein Mitarbeitender pro Monat</strong> in Meetings?
            </MxCostCalculatorQuestion>

            <SliderElement
              start={this.state.monthlyMeetingHours}
              onUpdate={value =>
                this.updateValueSlider("monthlyMeetingHours", value)
              }
              min={0}
              max={100}
            />
          </div>
          <div className="w-full mt-24 px-6 mb-24">
            <MxCostCalculatorQuestion minHeight={60}>
              Wie <strong>effizient</strong> schätzen Sie die Meetings in Ihrem
              Unternehmen? (0 - 100)
            </MxCostCalculatorQuestion>

            <SliderElement
              start={this.state.meetingScore}
              onUpdate={value => this.updateValueSlider("meetingScore", value)}
              min={0}
              max={100}
            />
          </div>
        </div>

        {!this.state.showDamage && (
          <div className="text-center">
            <button
              type="button"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-pink-600 hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
              onClick={() => this.revealDamage()}
            >
              Kosten jetzt berechnen
            </button>
          </div>
        )}

        {this.state.showDamage && (
          <div className="text-center">
            <p className="text-2xl leading-snug">
              Ihr Meeting Score verursacht aktuell einen Schaden von ca.{" "}
              <strong className="font-extrabold">
                {this.currencyFormatter.format(damage * 12)}
              </strong>{" "}
              pro Jahr.
            </p>

            <a href="/product/meeting-experience">
              <button
                type="button"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-pink-600 hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
              >
                Jetzt den Meeting Score verbessern!
              </button>
            </a>
          </div>
        )}
      </div>
    );
  }
}
